import { render, staticRenderFns } from "./users-table.vue?vue&type=template&id=5bfae200&"
import script from "./users-table.vue?vue&type=script&lang=ts&"
export * from "./users-table.vue?vue&type=script&lang=ts&"
import style0 from "./users-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports